/*
 *  -----------------------------------------------------------------------
 *    <copyright file="multi-select-no-results.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cn from 'clsx';
import React from 'react';
import Button from '@components/core/buttons';
import { useTranslation } from '@hooks/index';

const MultiSelectNoResults = ({ addNewAction }: { addNewAction?: () => void }) => {
    const { t } = useTranslation();

    return (
        <div className={cn('multi-select-no-results', { 'k-pr-0 k-display-flex': !!addNewAction })}>
            {t('noResults')}
            {!!addNewAction && (
                <Button onClick={addNewAction} className="multi-select-add-new" data-testid="multi-select-add-new">
                    <FontAwesomeIcon icon={['fal', 'plus']} />
                </Button>
            )}
        </div>
    );
};

export default MultiSelectNoResults;
